// @ts-expect-error file not migrated yet
import propertyValueToNumber from 'customer-data-sidebar/universal/dataAccessHelpers/propertyValueToNumber';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { getPropertyValueFromProperties } from '../../../../helpers/propertiesHelpers';
import { DISPLAY_LABEL_FALLBACK } from '../../../../constants/displayLabelFallback';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const useGetAlertChickletSecondaryDisplayLabels = ({
  properties
}) => {
  const alertCreateDate = propertyValueToNumber(getPropertyValueFromProperties(properties, 'hs_createdate'));
  const renderCreateDate = () => {
    const dateText = alertCreateDate ? /*#__PURE__*/_jsx(FormattedDateTime, {
      value: alertCreateDate,
      type: "userTz",
      format: "LL"
    }) : DISPLAY_LABEL_FALLBACK;
    return /*#__PURE__*/_jsxs("div", {
      "data-selenium-test": "alert-chicklet-create-date",
      "data-test-id": "alert-chicklet-create-date",
      children: [/*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "cardAssociatedObjects.chicklet.AlertChicklet.createDateLabel",
        useGap: true
      }), dateText]
    });
  };
  const propertyFormatters = {
    hs_pipeline_stage: () => null,
    // This will be added once backend is updated
    hs_createdate: renderCreateDate
  };
  return {
    propertyFormatters,
    copyDisabled: false
  };
};
export default useGetAlertChickletSecondaryDisplayLabels;